export const MONTHS = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
export const MONTHS_SHORT = ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Août", "Sep", "Oct", "Nov", "Déc"];

export const PLANNING_TYPES = [
  { key: "travaille", label: "Travaillé", color: "#002FA7" },
  { key: "repos", label: "Repos", color: "#868E96" },
  { key: "conge", label: "Congé", color: "#0066FF" },
  { key: "conge_paye", label: "Congé payé", color: "#059669" },
  { key: "absence_maladie", label: "Maladie", color: "#E60000" },
  { key: "jour_ferie", label: "Jour férié", color: "#FFD700" },
];

export const NETWORK_MODES = {
  multi: {
    label: "Réseau intégré",
    short: "Multi-sites",
    desc: "Le siège centralise congés et finance. Les responsables gèrent le planning de leur équipe.",
  },
  franchise: {
    label: "Franchise / réseau",
    short: "Franchise",
    desc: "Chaque établissement est autonome : le responsable valide les congés et saisit son CA. Le siège garde la vue globale.",
  },
};

export const eur = (v) => `${(Number(v) || 0).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
export const hours = (v) => `${(Number(v) || 0).toLocaleString("fr-FR", { maximumFractionDigits: 1 })} h`;
export const monthKey = (d = new Date()) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
export const monthLabel = (key) => {
  if (!key) return "";
  const [y, m] = key.split("-").map(Number);
  return `${MONTHS[m - 1]} ${y}`;
};
export const shiftMonth = (key, dir) => {
  const [y, m] = key.split("-").map(Number);
  const d = new Date(y, m - 1 + dir, 1);
  return monthKey(d);
};
export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("fr-FR") : "—");
export const fullName = (s) => (s ? `${s.prenom || ""} ${s.nom || ""}`.trim() || s.code : "—");
